<template>
  <v-container>
    <h2>Eventi</h2>
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th>Data inizio</th>
            <th>Data fine</th>
            <th>Tipo</th>
            <th>Luogo</th>
            <th>Concerto</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="event in filteredEvents" :key="event.id">
            <td>
              {{ $formatDate($parseDate(event.start_date), "d MMMM y, H:mm") }}
            </td>
            <td>
              {{ $formatDate($parseDate(event.end_date), "d MMMM y, H:mm") }}
            </td>
            <td>{{ eventKinds[event.kind] }}</td>
            <td>
              {{
                get(
                  showPlaces.find((p) => p.id === event.place),
                  "place__name"
                )
              }}
            </td>
            <td>
              {{
                get(
                  concerts.find((c) => c.id === event.concert),
                  "short_title"
                )
              }}
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>

    <p style="margin-top: 20px;">
      Info: Alfredo Bruno | Sofia Andreoli - Tel: +393761223166 - Mail:
      directorassistant@oficinaocm.com
      <br />
      Info travel/accomodation: Kati Gerola - Tel: +393517701823 - Mail:
      welcome@oficinaocm.com
    </p>
  </v-container>
</template>

<script>
import { mapState } from "vuex"

export default {
  data() {
    return {
      eventKinds: {
        1: "evento pubblico",
        2: "prova",
        3: "accordatura",
      },
    }
  },
  computed: {
    showFk() {
      return this.$route.params.id
    },
    instrumentFk() {
      return this.$route.params.instrumentId
    },
    filteredEvents() {
      return this.events.filter((event) => {
        return event.instruments.includes(parseInt(this.instrumentFk))
      })
    },
    filteredConcerts() {
      // get all concerts from the events
      const ids = this.filteredEvents
        .map((e) => e.concert)
        // get their unique ids
        .filter((v, i, a) => a.indexOf(v) === i)

      // map ids to concerts
      return ids.map((id) => this.concerts.find((p) => p.id === id))
    },
    ...mapState({
      loading(state) {
        return (
          state.events.pending.allEvents &&
          state.shows.pending.allConcerts &&
          // state.shows.pending.allShowinstruments &&
          state.shows.pending.show
        )
      },
      events(state) {
        return state.events.allEvents
      },
      concerts(state) {
        return state.concerts.allConcerts
      },
      showPlaces(state) {
        return state.shows.allShowPlaces
      },
      // showinstruments(state) {
      //   return state.shows.allShowinstruments
      // },
    }),
  },
  mounted() {
    this.fetch()
  },
  methods: {
    fetch() {
      this.$store.dispatch("listAllEvents", {
        params: { show: this.showFk },
      })
      this.$store.dispatch("listAllConcerts", {
        params: { show: this.showFk },
      }),
        this.$store.dispatch("listAllShowPlaces", {
          params: { show: this.showFk },
        })
      // this.$store.dispatch("listAllShowinstruments", {
      //   params: { show: this.showFk },
      // })
    },
  },
}
</script>
